import React from 'react';
export function SocialProof() {
  return <section className="bg-brand-grayLight py-12 border-y border-slate-100" data-id="element-273">
      <div className="max-w-4xl mx-auto px-5" data-id="element-274">
        <p className="text-center text-[10px] font-bold text-slate-400 uppercase tracking-[0.2em] mb-10" data-id="element-275">
          CONFIADO POR PROFESIONALES DEL COLOR
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-276">
          <StatItem value="+2,000" label="ESTILISTAS YA LO UTILIZAN" data-id="element-277" />
          <StatItem value="6" label="TOMOS COMPLETOS" data-id="element-278" />
          <StatItem value="4.9/5" label="CALIFICACIÓN ⭐" data-id="element-279" />
          <StatItem value="🌎" label="Argentina y Latinoamérica" isEmoji data-id="element-280" />
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 mt-10 pt-8 border-t border-slate-200" data-id="element-281">
          <span className="text-sm text-slate-500 font-semibold" data-id="element-282">
            📄 100% digital (PDF)
          </span>
          <span className="text-sm text-slate-500 font-semibold" data-id="element-283">
            ⚡ Acceso inmediato
          </span>
          <span className="text-sm text-slate-600 font-bold text-center w-full mt-2" data-id="element-284">
            🧠 Para estilistas, peluqueros y coloristas que quieren resultados
            más profesionales
          </span>
        </div>
      </div>
    </section>;
}
function StatItem({
  value,
  label,
  isEmoji
}: {
  value: string;
  label: string;
  isEmoji?: boolean;
}) {
  return <div className="flex flex-col items-center justify-center" data-id="element-285">
      <div className={`${isEmoji ? 'text-4xl' : 'text-3xl md:text-4xl'} font-black text-[#C8A96B] mb-2`} data-id="element-286">
        {value}
      </div>
      <div className="text-[10px] md:text-xs text-slate-500 font-bold uppercase tracking-wider leading-tight max-w-[120px]" data-id="element-287">
        {label}
      </div>
    </div>;
}